var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "blockWrapper",
      class: [
        "buttons-bottom-header__item _with-popup",
        { "_with-popup--active": _vm.isPopupShow },
      ],
      attrs: { "data-list-type": "jsCompareProduct" },
    },
    [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__link",
          attrs: { href: "/catalog/compare.php" },
        },
        [
          _c("div", { staticClass: "buttons-bottom-header__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "20",
                  height: "21",
                  viewBox: "0 0 20 21",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9.73047 18.6191H10.7305V2.61914H9.73047V18.6191ZM8.73047 0.619141C8.17818 0.619141 7.73047 1.06686 7.73047 1.61914V19.6191C7.73047 20.1714 8.17818 20.6191 8.73047 20.6191H11.7305C12.2828 20.6191 12.7305 20.1714 12.7305 19.6191V1.61914C12.7305 1.06686 12.2828 0.619141 11.7305 0.619141H8.73047ZM2.73047 12.6191V18.6191H3.73047V12.6191H2.73047ZM1.73047 10.6191C1.17818 10.6191 0.730469 11.0669 0.730469 11.6191V19.6191C0.730469 20.1714 1.17818 20.6191 1.73047 20.6191H4.73047C5.28275 20.6191 5.73047 20.1714 5.73047 19.6191V11.6191C5.73047 11.0669 5.28275 10.6191 4.73047 10.6191H1.73047ZM16.7305 18.6191V7.61914H17.7305V18.6191H16.7305ZM14.7305 6.61914C14.7305 6.06686 15.1782 5.61914 15.7305 5.61914H18.7305C19.2828 5.61914 19.7305 6.06686 19.7305 6.61914V19.6191C19.7305 20.1714 19.2828 20.6191 18.7305 20.6191H15.7305C15.1782 20.6191 14.7305 20.1714 14.7305 19.6191V6.61914Z",
                    fill: "#474747",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items-count", staticStyle: { display: "none" } },
              [_vm._v("1")]
            ),
            _vm._v(" "),
            _vm.countItems > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "buttons-bottom-header__icon-count items-count__show",
                  },
                  [_vm._v("\n        " + _vm._s(_vm.countItems) + "\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("Сравнить")]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "buttons-bottom-header__item-popup" }, [
        _c(
          "div",
          {
            staticClass:
              "buttons-bottom-header__added-products jsCompareProduct",
          },
          [
            _vm._l(_vm.items, function (item, key) {
              return [
                _c("header-product", {
                  key: "header-compare-product-" + key,
                  attrs: { item: item },
                  on: { deleteItem: _vm.deleteItem },
                }),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buttons-bottom-header__btn-wrapper" }, [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__btn _btn",
          attrs: { href: "/catalog/compare.php" },
        },
        [_c("p", [_vm._v("Сравнить товары")]), _vm._v(" "), _c("span")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }